<template>
  <div class="app-header">
    <div class="row">
      <div class="shrink columns">
        <img class="app-header__logo" :src="app.icon" alt="" />
      </div>

      <div class="app-header__descriptions-wrapper columns">
        <div class="app-header__description">
          <AlternativeSelect
            :items="apps"
            :value="app.packageName"
            class="app-header__title-select"
            filterable
            popper-class="app-header__title-popper"
            key-prop="id"
            label-prop="name"
            value-prop="packageName"
            :loading="isLoading"
            @change="currentAppChanged"
          />
        </div>

        <div class="app-header__description">
          <span class="show-for-large text-secondary app-header__label">
            {{ $t('APPS.PACKAGE_NAME') }}:
          </span>
          <a
            :href="`https://cafebazaar.ir/app/${app.packageName}`"
            target="_blank"
          >
            {{ app.packageName }}&nbsp;
            <i class="material-icons app-header__icon">
              open_in_new
            </i>
          </a>
        </div>

        <div class="app-header__description text-latin">
          <div class="app-header__state">
            <span class="show-for-large text-secondary app-header__label">
              {{ $t('APPS.LIST.STATUS') }}:
            </span>
            <span :class="appStateClasses">
              {{ getAppState(app.published) }}
            </span>
            <i
              class="material-icons app-header__icon"
              @click="openModal('stateDescriptionModal')"
            >
              info_outline
            </i>
          </div>

          <AppActions v-if="hasPublish(packageName)" />
        </div>
      </div>
    </div>
    <AppStateDescModal v-model="stateDescriptionModal" />
  </div>
</template>

<script>
import AppActions from './AppActions';
import AlternativeSelect from '@@/common/AlternativeSelect';
import AppStateDescModal from './modal/AppStateDescModal';

import { APP_DETAILS, APPS, UNSET_APP } from '@/store/types';
import { mapGetters, mapActions } from 'vuex';
import appState from '@/mixins/appState';
import permissions from '@/mixins/permissions';
import packageName from '@/mixins/packageName';
import modal from '@/mixins/modal';

export default {
  name: 'AppHeader',

  components: {
    AppActions,
    AlternativeSelect,
    AppStateDescModal,
  },

  mixins: [packageName, appState, modal, permissions],

  data() {
    return {
      isLoading: false,
      stateDescriptionModal: false,
    };
  },

  computed: {
    ...mapGetters({
      app: APP_DETAILS,
      apps: APPS,
    }),

    appStateClasses() {
      const { published } = this.app;
      return {
        'text-success': ['P', 'B'].includes(published),
        'text-alert': ['E', 'D', 'R', 'J'].includes(published),
        'text-warning': ['S', 'C', 'H'].includes(published),
        'text-info': ['A', 'N', 'U'].includes(published),
      };
    },
  },

  created() {
    if (!this.apps.length) {
      this.getApps().catch(({ message }) => {
        this.$message.error(message);
      });
    }
    this.getAppDetail(this.packageName);
  },

  beforeDestroy() {
    this.unsetApp();
  },

  methods: {
    ...mapActions({
      getApps: APPS,
      dispatchAppDetails: APP_DETAILS,
      unsetApp: UNSET_APP,
    }),

    currentAppChanged(packageName) {
      const { name } = this.$route;
      const targetName = name === 'app-ticket-detail' ? 'app-tickets' : name;
      this.unsetApp();
      this.$router.push({ name: targetName, params: { packageName } });
      this.getAppDetail(packageName);
    },

    getAppDetail(packageName) {
      this.isLoading = true;
      return this.dispatchAppDetails(packageName)
        .catch(message => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.app-header {
  &__descriptions-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__title-select,
  &__title-popper {
    max-width: rem-calc(200);
  }

  &__title {
    position: relative;
  }

  &__title-loading {
    position: absolute;
    height: 100%;
    background-color: rgba(#fff, 0.8);
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    font-size: 1rem;
  }

  &__description {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
  }

  &__state {
    margin-right: $global-margin;

    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
    }

    .material-icons {
      font-size: $lb-button-font-size;
      cursor: pointer;
    }
  }

  &__logo {
    width: rem-calc(100);
    height: rem-calc(100);

    &:not([src]) {
      border: 1px solid #c0c0c0;
    }

    @include breakpoint(large) {
      width: rem-calc(130);
      height: rem-calc(130);
    }
  }

  &__label {
    margin-right: $global-margin * 0.3;

    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin * 0.3;
    }
  }
}
</style>
